var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"danger-total__table-cell danger-total__table-cell_body danger-total__table-cell_tar"},[_c('span',{staticClass:"danger-total__table-value"},[_vm._v(_vm._s(_vm.format(_vm.compareRestaurantEventValue)))])])}
var staticRenderFns = []

export { render, staticRenderFns }